import { Component, OnInit } from '@angular/core';
import { companyInfo } from 'src/common';

@Component({
  selector: 'app-team',
  templateUrl: './team.component.html',
  styleUrls: ['./team.component.scss']
})
export class TeamComponent implements OnInit {

  constructor() { }

  public team=companyInfo.shareholders;
  ngOnInit(): void {
  }

}
